import DefaultMarkdown from "../../../DefaultMarkdown"
import { DbgPaths } from "../../../../../utils/Paths"
import React from "react"
import { ModalListItem } from "../ModalListItem"

export const OtherExpensesHeader = (): JSX.Element => {
  return (
    <p>
      <DefaultMarkdown
        source={
          "This category includes the following when you work with a [Carrot-eligible provider](" +
          DbgPaths.PROVIDER_ELIGIBILITY +
          "):"
        }
      />
    </p>
  )
}

export const OtherExpensesListItems = (props): JSX.Element => {
  const { benefitInfo, country, lineItemFilter, companyCoverage } = props
  const preservation = benefitInfo.journeys.fertilityPreservation
  const fertilityCare = benefitInfo.journeys.fertilityCare
  const hasElectiveFertilityLineItemFilter = lineItemFilter === "ELECTIVE_FERTILITY"
  const menopause = benefitInfo.journeys.menopause
  return (
    <>
      {companyCoverage.isMemberAndPartnerEligibe && !companyCoverage.areLegalPartnersEligible && (
        <ModalListItem>
          <DefaultMarkdown
            source={
              "Any [eligible care and services](" +
              DbgPaths.CARROT_ELIGIBLE +
              ") received by the member’s [Carrot-eligible partner](" +
              DbgPaths.CARROT_ELIGIBLE +
              ") , if not legally married or tax-dependent"
            }
          />
        </ModalListItem>
      )}
      {fertilityCare.eligibleExpensesDetail.isElectiveCareCovered && !hasElectiveFertilityLineItemFilter && (
        <ModalListItem>
          <DefaultMarkdown
            source={
              "Eligible [fertility care](" +
              DbgPaths.FERTILITY_COVERAGE +
              ") expenses not related to an infertility diagnosis issued by a fertility doctor"
            }
          />
        </ModalListItem>
      )}
      {fertilityCare.eligibleExpensesDetail.isElectiveCareCovered &&
        hasElectiveFertilityLineItemFilter &&
        fertilityCare.eligibleExpensesDetail.isCoveredWithInfertilityDiagnosis && (
          <ModalListItem>
            <DefaultMarkdown
              source={
                "Eligible [fertility care](" + DbgPaths.FERTILITY_COVERAGE + ") storage expenses after the first year"
              }
            />
          </ModalListItem>
        )}
      {fertilityCare.eligibleExpensesDetail.isElectiveCareCovered &&
        !hasElectiveFertilityLineItemFilter &&
        fertilityCare.eligibleExpensesDetail.isCoveredWithInfertilityDiagnosis && (
          <ModalListItem>
            <DefaultMarkdown
              source={
                "Eligible [fertility care](" +
                DbgPaths.FERTILITY_COVERAGE +
                ") storage expenses after the first year, with or without an infertility diagnosis"
              }
            />
          </ModalListItem>
        )}
      {fertilityCare.eligibleExpensesDetail.hasDonorAssistance && !hasElectiveFertilityLineItemFilter && (
        <ModalListItem>
          <DefaultMarkdown
            source={
              "Eligible [donor assistance](" +
              DbgPaths.DONOR_COVERAGE +
              ")  expenses related to fertility care, with or without an infertility diagnosis"
            }
          />
        </ModalListItem>
      )}
      {fertilityCare.eligibleExpensesDetail.hasDonorAssistance && hasElectiveFertilityLineItemFilter && (
        <ModalListItem>
          <DefaultMarkdown
            source={"Eligible [donor assistance](" + DbgPaths.DONOR_COVERAGE + ") expenses related to fertility care"}
          />
        </ModalListItem>
      )}
      {preservation.eligibleExpensesDetail.isElectivePreservationCovered && !hasElectiveFertilityLineItemFilter && (
        <ModalListItem>
          <DefaultMarkdown
            source={
              "Eligible [fertility preservation](" +
              DbgPaths.PRESERVATION_COVERAGE +
              ") expenses not related to an infertility diagnosis or medical necessity, as determined by a fertility doctor"
            }
          />
        </ModalListItem>
      )}
      {preservation.eligibleExpensesDetail.isElectivePreservationCovered &&
        preservation.eligibleExpensesDetail.isMedicallyNecessaryPreservationCovered &&
        hasElectiveFertilityLineItemFilter && (
          <ModalListItem>
            <DefaultMarkdown
              source={
                "Eligible [fertility preservation](" +
                DbgPaths.PRESERVATION_COVERAGE +
                ") storage expenses after the first year"
              }
            />
          </ModalListItem>
        )}
      {preservation.eligibleExpensesDetail.isElectivePreservationCovered &&
        preservation.eligibleExpensesDetail.isMedicallyNecessaryPreservationCovered &&
        !hasElectiveFertilityLineItemFilter && (
          <ModalListItem>
            <DefaultMarkdown
              source={
                "Eligible [fertility preservation](" +
                DbgPaths.PRESERVATION_COVERAGE +
                ") storage expenses after the first year, with or without an infertility diagnosis or medical necessity"
              }
            />
          </ModalListItem>
        )}
      {benefitInfo.journeys.adoption.hasEligibleExpenses && (
        <ModalListItem>
          <DefaultMarkdown source={"Eligible [adoption](" + DbgPaths.ADOPTION_COVERAGE + ") expenses"} />
        </ModalListItem>
      )}
      {benefitInfo.journeys.gestationalCarrier.hasEligibleExpenses && (
        <ModalListItem>
          <DefaultMarkdown
            source={
              "Eligible [gestational surrogacy](" +
              DbgPaths.GESTATIONAL_SURROGACY_COVERAGE +
              ") expenses, including related donor assistance"
            }
          />
        </ModalListItem>
      )}
      {benefitInfo.journeys.pregnancy.hasEligibleExpenses && (
        <ModalListItem>
          <DefaultMarkdown
            source={"Eligible [pregnancy and postpartum](" + DbgPaths.PREGNANCY_COVERAGE + ") expenses"}
          />
        </ModalListItem>
      )}
      {menopause.hasEligibleExpenses && ["US", "AU"].includes(country) && (
        <ModalListItem>
          <DefaultMarkdown
            source={"Eligible Eight Sleep and Perfectly Snug products for [menopause](" + DbgPaths.MENOPAUSE + ")"}
          />
        </ModalListItem>
      )}
      {menopause.hasEligibleExpenses && ["GB", "DE"].includes(country) && (
        <ModalListItem>
          <DefaultMarkdown source={"Eligible Eight Sleep products for [menopause](" + DbgPaths.MENOPAUSE + ")"} />
        </ModalListItem>
      )}
    </>
  )
}
